import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  root: {
    position: 'relative'
  }
}));
